export function freezeWindowScroll() {
    Object.assign(document.documentElement.style, {
        overflow: 'hidden',
    });
    Object.assign(document.body.style, {
        overflow: 'visible',
        height: '100%',
    });
}
export function unfreezeWindowScroll() {
    Object.assign(document.documentElement.style, {
        overflow: '',
    });
    Object.assign(document.body.style, {
        overflow: '',
        height: '',
    });
}
let isOpera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
let isChrome = !isOpera && navigator.userAgent.indexOf('Chrome') > -1;
let isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
let isSafari = !isChrome && navigator.userAgent.indexOf("Safari") > -1;
export const browser = Object.freeze({ isOpera, isChrome, isFirefox, isSafari });
const ONE_HOUR_MS = 3600000;
const ONE_WEEK_MS = ONE_HOUR_MS * 24 * 7;
export function formatTime(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}
export function formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return `${date.getFullYear()}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
}
export function niceDateFromISO8601(dateStr) {
    const then_ms = Date.parse(dateStr);
    const diff_ms = Date.now() - then_ms;
    if (diff_ms < ONE_HOUR_MS) {
        // Within the last hour
        return `${Math.round(diff_ms / 60000)} min sedan`;
    }
    const dtNow = new Date();
    const dtThen = new Date(then_ms);
    if (diff_ms < 48 * ONE_HOUR_MS) {
        if (dtThen.getDay() !== dtNow.getDay()) {
            // Yesterday
            return `Igår ${formatTime(dtThen)}`;
        }
        else if (diff_ms < 6 * ONE_HOUR_MS) {
            // Today, up to 6 hours ago
            return `${Math.round(diff_ms / ONE_HOUR_MS)} timmar sedan`;
        }
        // Today, more than 6 hours ago
        return `Idag ${formatTime(dtThen)}`;
    }
    if (diff_ms < ONE_WEEK_MS) {
        // Within the last week
        return `${Math.round(diff_ms / ONE_HOUR_MS / 24)} dagar sedan`;
    }
    // More than a week ago
    return formatDate(dtThen);
}
/**
 * This promise will not resolve if Cookiebot is not loaded
 */
//export function waitForCookiebot(): Promise<typeof window.Cookiebot> {
//    return new Promise(async resolve => {
//        let api = null;
//        function checkApi() {
//            if (window.Cookiebot) {
//                api = window.Cookiebot;
//            }
//        }
//        while (!api) {
//            checkApi();
//            await new Promise(r => setTimeout(r, 100));
//        }
//        resolve(api);
//    });
//}
